import React from 'react'
import Skeleton from 'react-loading-skeleton'

function PostHeadingAndOtherStuffSkeleton() {
    return (
        <div className="blog-title px-md-5">
            <Skeleton className="title-big" />
            <ul className="blog-list">
                <li>
                    <p> Posted on <strong><Skeleton /></strong></p>
                </li>
                <li>
                    <p> By <a href={`/`}><strong><Skeleton /></strong></a></p>
                </li>
                <li>
                    <p> <strong><Skeleton /></strong></p>
                </li>
            </ul>
        </div>
    )
}

export default PostHeadingAndOtherStuffSkeleton
